var map = {
	"./font-butler.css": [
		9596,
		596
	],
	"./font-cormorant_infant.css": [
		5203,
		203
	],
	"./font-im_fell_double_pica.css": [
		1541,
		541
	],
	"./font-im_fell_dw_pica.css": [
		9214,
		214
	],
	"./font-inter.css": [
		4797,
		797
	],
	"./font-lora.css": [
		8111,
		111
	],
	"./font-noto-sans.css": [
		9247,
		247
	],
	"./font-noto_serif_tibetan.css": [
		8990,
		990
	],
	"./font-roboto.css": [
		3393,
		393
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4234;
module.exports = webpackAsyncContext;